import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface PaymentGatewayModalPayload {
  data?: null;
  type: ModalType.PaymentGateway;
  isOpen?: boolean;
}

export const PaymentGatewayModal = React.forwardRef<
  HTMLElement,
  Pick<PaymentGatewayModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="Universal Payment Gateway"
      subtitle="Pay Anywhere with Crypto"
      icon={<Icons.CreditCardDark />}
      link={{
        title: 'Start Trading',
        link: {
          href: ECOSYSTEM_LINKS.useCases,
          text: ECOSYSTEM_LINKS.useCases,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        The Universal Payment Gateway is the payment layer of CratD2C.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        It allows businesses to accept $CRAT and other digital assets online and offline, with support for a crypto
        debit card.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        For everyday users, this feels like using a normal payment system - but faster, cheaper, and border-friendly,
        thanks to blockchain.
      </Typography>
    </ModalSidebar>
  );
});
